import React from 'react';
import classNames from 'classnames';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { ParagraphsRenderer, VariableRatiosPicture } from '../../../components';
import type { NodeOverviewPage as Type } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface OverviewPageProps {
  entity: ImmutableEntity<Type>;
  className?: string;
}

const NodeOverviewPage: React.FC<OverviewPageProps> = ({ entity, className }) => {
  const overviewPage = entity.toJS();
  const title = overviewPage.title[0].value;
  const body = overviewPage.body[0]?.processed;
  const heroImage = overviewPage.field_media_item[0];
  const darkmode = overviewPage.field_labels.find((label) => label.entity.name[0].value.toLowerCase() === 'darkmode') && true;

  const classes = classNames('Node', 'NodeOverviewPage', className, {
    'NodeOverviewPage--darkmode': darkmode,
  });

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <div className="NodeOverviewPage__hero">
        {!darkmode && (
          <div className="NodeOverviewPage__hero__image-wrapper">
            <div className="NodeOverviewPage__hero__image">
              <VariableRatiosPicture
                image={heroImage}
                aspectRatios={['16_9', '16_9', '16_9', '2_1', '3_1']}
                cropSizes={['sm', 'md', 'lg', 'lg', 'xl']}
              />
            </div>
          </div>
        )}
        <Container className="NodeOverviewPage__hero__text-container">
          <div className="NodeOverviewPage__hero__text-wrapper">
            <div className="row">
              <div className={darkmode ? 'col-12 col-md-10 col-lg-8' : 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-1'}>
                <h1 className="NodeOverviewPage__title" itemProp="title">
                  {title}
                </h1>

                {body && (
                  <WysiwygField
                    className="NodeOverviewPage__body body--large"
                    property="schema:text"
                    html={body}
                  />
                )}
              </div>
            </div>
          </div>
        </Container>
      </div>

      <ParagraphsRenderer
        className="NodeOverviewPage__paragraphs"
        paragraphs={entity.get('field_paragraphs')}
        isWide={darkmode || false}
        {...(darkmode && {
          only: ['content_overview'],
        })}
      />
    </article>
  );
};

export default NodeOverviewPage;
